import type { FC } from 'react';

import { Typography } from '@packages/shared/src/components/Typography/Typography';

import type { ResponsiveNavigationItemBaseProps } from '../ResponsiveNavigationItemBase';
import { ResponsiveNavigationItemBase } from '../ResponsiveNavigationItemBase';

export type ResponsiveFlyoutItemProps = Omit<
  ResponsiveNavigationItemBaseProps,
  'sxListItem' | 'sxLink'
>;

/**
 * Navigation item for the popup navigation (only visible on user interaction)
 */
export const ResponsiveFlyoutItem: FC<ResponsiveFlyoutItemProps> = ({ children, ...baseProps }) => {
  const { allowNavigation } = baseProps;
  return (
    <ResponsiveNavigationItemBase
      {...baseProps}
      sxListItem={{
        alignItems: 'flex-start',
        borderBottom: (theme) => ({ xs: `1px solid ${theme.palette.grey.main}`, lg: 'none' }),
        // borderColor: 'grey.main', // TODO figure out why this does not work, without media queries it does work combined with `borderBottom: '1px solid'`
      }}
      sxLink={{
        paddingX: { xs: 2, lg: 0 },
        paddingY: { xs: 1.5, lg: 0 },
        fontSize: '2rem',
        transition: 'background-color 0.25s',
        '&:hover': { backgroundColor: 'white' },
        minHeight: '1em', // to match the height of the arrow icon for categories with children
        justifyContent: 'space-between',
      }}
    >
      {/* NOTE top margin is used instead of centering to allow top-alignment in the `li` combined with having the arrow centered with the first line of text */}
      <Typography variant="h5" component="span" position="relative" marginY="0.4em">
        {children}
      </Typography>
      {!allowNavigation && <span className="icon-emp-arrow-medium-right size-4" />}
    </ResponsiveNavigationItemBase>
  );
};
